import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureToggle } from '~/platform/utilities/feature-toggles/useFeatureToggle';
import ArpActionLink from './ArpActionLink';
import { quickSubmitUrls, withBasename } from '../utilities/quickSubmit';

const SubmitFormsAndFilesContent = ({ claimantId = null }) => {
  const { TOGGLE_NAMES, useToggleValue } = useFeatureToggle();

  const isSubmit686cEnabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalSubmit686cV2,
  );

  const isQuickSubmitEnabled = useToggleValue(
    TOGGLE_NAMES.accreditedRepresentativePortalCdUpdateQsLink,
  );

  return (
    <>
      <va-card>
        <h3 className="vads-u-margin--0">
          Submit online forms for fastest processing
        </h3>
        <p className="vads-u-line-height--3 vads-u-margin-top--0 subtext-gray">
          Fill out and submit online forms, with or without supporting
          documents. Online forms can establish in VBMS as quickly as one hour
          after submission.
        </p>
        {isSubmit686cEnabled && (
          <ArpActionLink
            href={`/representative/representative-form-upload/va-form-21-686c-674/introduction${
              claimantId ? `?claimantId=${claimantId}` : ''
            }`}
            text="Start VA Form 21-686c and 21-674 (Add or Remove Dependents)"
            icon="groups"
            className="vads-u-margin-top--2"
            backgroundColor="hub-service-member"
          />
        )}
        <ArpActionLink
          href="/representative/representative-form-upload/submit-va-form-21-0966/introduction"
          text="Start VA Form 21-0966 (Intent to File)"
          icon="event_available"
          className="vads-u-margin-top--2"
          backgroundColor="hub-records"
        />
      </va-card>
      <va-card class="vads-u-margin-top--2">
        <h3 className="vads-u-margin--0">Submit other forms</h3>
        <p className="vads-u-line-height--3 vads-u-margin-top--0 subtext-gray">
          Upload and submit completed VA forms, with or without supporting
          documents.
        </p>
        <ArpActionLink
          href="/representative/representative-form-upload/submit-va-form-21-526ez/introduction"
          text="Upload VA Form 21-526ez (Disability claim)"
          icon="description_outlined"
          className="vads-u-margin-top--2"
          backgroundColor="hub-disability"
        />
        {!isSubmit686cEnabled && (
          <ArpActionLink
            href="/representative/representative-form-upload/submit-va-form-21-686c/introduction"
            text="Upload VA Form 21-686c (Add and/or Remove Dependents)"
            icon="groups"
            className="vads-u-margin-top--2"
            backgroundColor="hub-service-member"
          />
        )}
        <va-link-action
          href="/representative/representative-form-upload/submit-other-forms/introduction"
          text="Upload and submit other forms"
          type="secondary"
          class="vads-u-margin-top--1"
        />
      </va-card>
      {isQuickSubmitEnabled && (
        <va-card class="vads-u-margin-top--2">
          <h3 className="vads-u-margin--0">Upload any file with QuickSubmit</h3>
          <p className="vads-u-line-height--3 vads-u-margin-top--0 subtext-gray">
            Upload VA forms, supporting documents, or multiple files as a
            packet. You can use the integrated eForms to complete the forms you
            want to upload.
          </p>
          <va-link-action
            href={withBasename(quickSubmitUrls({ claimantId }).upload)}
            text="Upload with QuickSubmit"
            type="secondary"
            class="vads-u-margin-top--neg1"
          />
        </va-card>
      )}
    </>
  );
};

SubmitFormsAndFilesContent.propTypes = {
  claimantId: PropTypes.string,
};

export default SubmitFormsAndFilesContent;
